import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, } from 'reactstrap';

import ParadigmaModal from "../../../../../components/ParadigmaModal/ParadigmaModal.js";

import TabDetalle from './TabDetalle.js';
import TabImagenes from './TabImagenes.js';
import TabPropiedades from './TabPropiedades.js';
import TabRelacionados from './TabRelacionados.js';

import api from "../../../../../api";
import '../styles.css';

class ArticulosModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Codigo: "",
      Categoria_id: null,
      Titulo: "",
      Descripcion: "<p></p>",
      Info: "<p></p>",
      Imagenes: [],
      Valores: [],
      Colores: [],
      Talles: [],
      related_ids: [],
      Show: false,
      Link: "",

      postVariables: ['Categoria_id', 'Titulo', 'Descripcion', 'Info', 'Imagenes', 'Valores', 'related_ids', 'Show'],
      errors: [],

      activeTab: props.activeTab ? props.activeTab : "1",
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['EDIT', 'DETAIL']).isRequired,
  }

  resetForm() {
    this.setState({
      Codigo: "",
      Categoria_id: null,
      Titulo: "",
      Descripcion: "<p></p>",
      Info: "<p></p>",
      Link: "",
      Imagenes: [],
      Valores: [],
      Colores: [],
      Talles: [],
      related_ids: [],
      Show: false,
      errors: [],
      activeTab: this.props.activeTab ? this.props.activeTab : "1",
    });
  }

  getData() {
    const { postVariables } = this.state;
    let data = {};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });
    return data;
  }

  setData(data) {
    if (data.success) {
      this.setState({
        Codigo: data.Codigo,
        Categoria_id: data.Categoria_id,
        Titulo: data.Titulo,
        Descripcion: data.Descripcion && data.Descripcion.length > 0 ? data.Descripcion : "<p></p>",
        Info: data.Info && data.Info.length > 0 ? data.Info : "<p></p>",
        Imagenes: data.Imagenes ? data.Imagenes.map((item, idx) => ({ ...item, Order: idx + 1 })) : [],
        // Imagenes: data.Imagenes ? data.Imagenes.map((item, idx) => ({ src: item, Order: idx + 1 })) : [],
        Valores: data.Valores ? data.Valores : [],
        Colores: data.Colores ? data.Colores : [],
        Talles: data.Talles ? data.Talles : [],
        related_ids: data.related_ids ? data.related_ids : [],
        Link: data.link,
        Show: data.Show,
      })
    }
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  modalVars() {
    const { action } = this.props;
    if (action == "EDIT") {
      return {
        get: true,
        submitType: "PUT",
        title: `Editar Articulo - ${this.state.Titulo}`,
        buttonTitle: "Editar",
        saveButtonLabel: "Guardar",
        danger: false,
        buttonIcon: "fa fa-pencil fa-lg",
        successMessage: "El Articulo ha sido editado con éxito.",
        saveButton: true,
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      };
    } else if (action == "DETAIL") {
      return {
        get: true,
        submitType: null,
        title: `Articulo - ${this.state.Titulo}`,
        buttonTitle: "Ver",
        danger: false,
        buttonIcon: "fa fa-search fa-lg",
        successMessage: "",
        saveButton: false,
        buttonClass: "",
        disabled: true,
        id: this.props.id,
      };
    } else if (action == "IMAGES") {
      return {
        get: true,
        submitType: "PUT",
        title: `Editar Articulo - ${this.state.Titulo}`,
        buttonTitle: "Imagenes",
        saveButtonLabel: "Guardar",
        danger: false,
        buttonIcon: "fa fa-picture-o fa-lg",
        successMessage: "El Articulo ha sido editado con éxito.",
        saveButton: true,
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      }
    } else if (action == "PROPERTIES") {
      return {
        get: true,
        submitType: "PUT",
        title: `Editar Articulo - ${this.state.Titulo}`,
        buttonTitle: "Caracteristicas",
        saveButtonLabel: "Guardar",
        danger: false,
        buttonIcon: "fa fa-cogs fa-lg",
        successMessage: "El Articulo ha sido editado con éxito.",
        saveButton: true,
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      }
    } else if (action == "RELACIONADOS") {
      return {
        get: true,
        submitType: "PUT",
        title: `Editar Articulo - ${this.state.Titulo}`,
        buttonTitle: "Art. Relacionados",
        saveButtonLabel: "Guardar",
        danger: false,
        buttonIcon: "fa fa-link fa-lg",
        successMessage: "El Articulo ha sido editado con éxito.",
        saveButton: true,
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      }
    }
  }

  render() {
    let vars = this.modalVars();
    const toggleTab = (idx) => this.setState({ activeTab: idx });

    return (
      <ParadigmaModal
        getUrl={(vars.get ? api.gestion.articulos.articulos : null)}
        submitUrl={(vars.submitType ? api.gestion.articulos.articulos : null)}
        submitType={vars.submitType}
        id={vars.id}
        className="modal-lg"

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e)}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={vars.title}

        danger={vars.danger}
        buttonClass={vars.buttonClass}

        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}

        buttonTitle={vars.buttonTitle}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        closeButton={true}
      >
        <Nav tabs>

          <NavItem>
            <NavLink
              onClick={() => toggleTab('1')}
              className={this.state.activeTab == "1" ? "active" : ""}
            >
              <i class="fa fa-info" aria-hidden="true"></i> Detalle
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              onClick={() => toggleTab('2')}
              className={this.state.activeTab == "2" ? "active" : ""}
            >
              <i class="fa fa-picture-o" aria-hidden="true"></i> Imagenes
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              onClick={() => toggleTab('3')}
              className={this.state.activeTab == "3" ? "active" : ""}
            >
              <i class="fa fa-cogs" aria-hidden="true"></i> Caracteristicas
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              onClick={() => toggleTab('4')}
              className={this.state.activeTab == "4" ? "active" : ""}
            >
              <i class="fa fa-link" aria-hidden="true"></i> Art. Relacionados
            </NavLink>
          </NavItem>

        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabDetalle
            vars={vars}
            getError={(...data) => this.getError(...data)}
            onChangeField={(...data) => this.onChangeField(...data)}
            data={{
              Codigo: this.state.Codigo,
              Categoria_id: this.state.Categoria_id,
              Titulo: this.state.Titulo,
              Descripcion: this.state.Descripcion && this.state.Descripcion.length > 0 ? this.state.Descripcion : "<p></p>",
              Info: this.state.Info && this.state.Info.length > 0 ? this.state.Info : "<p></p>",
              Link: this.state.Link,
              Show: this.state.Show,
            }}
          />
          <TabImagenes
            vars={vars}
            onChangeField={(...data) => this.onChangeField(...data)}
            data={{
              Imagenes: this.state.Imagenes,
              Colores: this.state.Colores,
              Talles: this.state.Talles,
            }}
          />
          <TabPropiedades
            vars={vars}
            onChangeField={(...data) => this.onChangeField(...data)}
            data={{
              Valores: this.state.Valores,
            }}
          />
          <TabRelacionados
            vars={vars}
            onChangeField={(...data) => this.onChangeField(...data)}
            data={{
              related_ids: this.state.related_ids,
            }}
          />
        </TabContent>
      </ParadigmaModal>
    );
  }
}

export default ArticulosModal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/ModalArticulo/ArticulosModal.js